export default "__VITE_ASSET__4961ac16__"